import { render, staticRenderFns } from "./CreateAndModify.vue?vue&type=template&id=7ee87b47&scoped=true"
import script from "./CreateAndModify.vue?vue&type=script&lang=js"
export * from "./CreateAndModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee87b47",
  null
  
)

export default component.exports